import { ACTIONS_MATERIAL_CLASS } from '../_constants/materialClass.constants';

const initialState = {
  byId: {},
};

export function materialClassReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_MATERIAL_CLASS.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_MATERIAL_CLASS.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_MATERIAL_CLASS.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default materialClassReducer;
